<div class="page-wrapper" *ngIf="!isVerificationOtpModal" [ngClass]="{'modal': isLoginModal, 'page': !isLoginModal}">
  <ion-content>
    <div class="content">
      <ion-header>
        <ion-toolbar class="toolbar-header">
          @if(isLoginModal){
          <ion-buttons slot="end">
            <ion-button fill="clear" (click)="goBack()">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
          </ion-buttons>
          } @else {
          <ion-buttons slot="start">
            <ion-button>
              <ion-back-button defaultHref="/auth"></ion-back-button>
            </ion-button>
          </ion-buttons>
          }
        </ion-toolbar>
        <div class="header">
          <figure>
            <img [src]="logoSquare" alt="logo" />
          </figure>
          <h2 class="title">{{'Create Account' | translate}}</h2>
        </div>
      </ion-header>
      <div class="container " *ngIf="isEmailLogin">
        <form class="createAccount main-page-width" [formGroup]="form" (ngSubmit)="createAccount()">
          <ion-item lines="underline">
            <ion-input type="text" labelPlacement="floating" label="{{'First Name' | translate}}"
              formControlName="first_name" name="First name" required></ion-input>
          </ion-item>

          <ion-item lines="underline">
            <ion-input type="text" labelPlacement="floating" label="{{'Last Name' | translate}}"
              formControlName="last_name" name="Last name" required></ion-input>
          </ion-item>

          <ion-item lines="underline">
            <ion-input labelPlacement="floating" label="{{'Email' | translate}}" type="email" formControlName="email"
              name="Email" (ionInput)="trimEdgeSpacesIonInput(form, 'email', $event)" required></ion-input>
          </ion-item>

          <ion-text class="email-helper-text">{{'Must use valid email' | translate}}</ion-text>

          <ion-item lines="underline">
            <ion-input labelPlacement="floating" label="{{'PASSWORD' | translate}}"
              [type]="showPassword ? 'text' : 'password'" formControlName="password" name="Password" required>
            </ion-input>
            <ion-icon slot="end" [name]="showPassword ? 'eye' : 'eye-off'" (click)="togglePasswordVisibility()"
              class="eye-icon"></ion-icon>
          </ion-item>

          <ion-item lines="none" class="password-requirements">
            <div>
              <ion-text>{{'Your password must have' | translate}}:</ion-text>
              <ul style="list-style: none; padding: 0; margin: 0;">
                <li><ion-icon [name]="isPasswordLengthValid() ? 'checkbox' : 'square-outline'"></ion-icon> {{'8 or more
                  characters' | translate}}</li>
                <li><ion-icon [name]="isPasswordCaseValid() ? 'checkbox' : 'square-outline'"></ion-icon> {{'Upper and
                  lowercase letters' | translate}}</li>
                <li><ion-icon [name]="isPasswordNumberValid() ? 'checkbox' : 'square-outline'"></ion-icon> {{'At least
                  one number' | translate}}</li>
              </ul>
            </div>
          </ion-item>

          <ion-item class="strength-meter" *ngIf="form.get('password')?.value">
            <div>
              <div class="strength">{{'Strength' | translate}}: <span [class]="getPasswordStrength()">{{
                  getPasswordStrength() }}</span>
              </div>
              <div class="meter">
                <div class="bar" [ngClass]="getPasswordStrength()"
                  [style.width]="getPasswordStrength() === 'strong' ? '100%' : getPasswordStrength() === 'medium' ? '60%' : '30%'">
                </div>
              </div>
              <div class="warning" *ngIf="getPasswordStrength() === 'weak'">{{'This password is not secure. Try a
                different password.' | translate}}</div>
            </div>
          </ion-item>

          <div class="teram-conditions">
            <ion-note>{{'By continuing, you agree iOnCourt\'s' | translate}} <a
                (click)="openTermsAndConditions()">{{'Terms and Conditions' | translate}}</a>
              {{'and acknowledge it\'s' | translate}} <a (click)="openPrivacyPolicy()">{{'Privacy Policy' |
                translate}}</a> <br />
              {{'This site is protected by reCAPTCHA and the Google' | translate}}
              <a href="https://policies.google.com/privacy">{{'Privacy Policy' | translate}}</a> {{'and' | translate}}
              <a href="https://policies.google.com/terms">{{'Terms of Service' | translate}}</a> {{'apply' |
              translate}}.
            </ion-note>
          </div>
          <div class="btn-wrapper">
            <ion-button expand="block" class="primary-button ion-padding-bottom" type="submit" [disabled]="isLoading">
              <ion-spinner *ngIf="isLoading" name="crescent"></ion-spinner>
              {{ isLoading ? ('Creating Account...' | translate) : ('Create Account' | translate) }}
            </ion-button>
            <div class="ion-text-center ion-padding-bottom verify-code">
                <a (click)="changeForm()" style="color: #009688;">{{'Already have a code? Verify' | translate}}</a>
            </div>
          </div>
        </form>
      </div>
      <div class="sso-wrapper">
        <app-sso-buttons *ngIf="!isEmailLogin" (ssoLogin)="loginWithSSO($event)"
          (continueWithEmailAndPhone)="continueWithEmailAndPhone()" [emailBtnText]="'Continue with Email'"
          [isLoginModal]="isLoginModal">
        </app-sso-buttons>
      </div>
    </div>
  </ion-content>
</div>

<app-verification-otp *ngIf="isVerificationOtpModal"></app-verification-otp>